import { render } from "./ProductCategoriesTree.vue?vue&type=template&id=6df4e05a&scoped=true&ts=true"
import script from "./ProductCategoriesTree.vue?vue&type=script&lang=ts"
export * from "./ProductCategoriesTree.vue?vue&type=script&lang=ts"

import "./ProductCategoriesTree.vue?vue&type=style&index=0&id=6df4e05a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df4e05a"]])

export default __exports__